import DeclarationNumberInput from 'components/ui/composed/declarations/formInput/DeclarationNumberInput';
import FormSelect from 'components/ui/composed/declarations/formSelect/DeclarationSelect';
import useCodelists from 'hooks/useCodelists';
import useTooltips from 'hooks/useTooltips';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import { getFormikProps, getFullCodelistValue, handleToggleHelp } from 'views/declarations/utils/form-utils';
import addPathPrefix from '../../../../../../utils/addPathPrefix';
import { FormCardContainer } from '../../../../common/cards/NewFormCard';
import MultipleItemsCard from '../../../../common/MultipleItemsCard';
import { validators } from 'views/declarations/uk/export/validations/validations';
import CurrencySelect from 'components/ui/composed/declarations/CurrencySelect';

const AdditionsDeductionsCard: FC<DeclarationFormCardProps & { productDisabled?: boolean }> = (props) => {
    const { t } = useTranslation('form');
    const { aisCodelists } = useCodelists();
    const { getH1TooltipsByRefNumberAndField } = useTooltips();

    return (
        <MultipleItemsCard
            getFieldHelpers={props.getFieldHelpers}
            getFieldProps={props.getFieldProps}
            path={props.propsPathPrefix!}
            initialValues={{ additionsDeductionsCode: undefined, amount: '', currency: undefined, currencyAmount: '' }}
            list={(list) => [
                {
                    field: t('code'),
                    value: getFullCodelistValue(list.additionsDeductionsCode, aisCodelists?.additionsDeductionsCode),
                },

                {
                    field: 'Currency',
                    value: list.currency,
                },
                {
                    field: 'Currency Amount',
                    value: list.currencyAmount,
                },
                {
                    field: t('amount'),
                    value: list.amount,
                },
            ]}
            defaultOpen={props.defaultOpen}
            viewOnly={props.viewOnly}
            keyCard={props.keyCard}
            title={t('additionsDeductions')}
            condensed
            refNumber="4.9"
            form={(formProps, path) => (
                <FormCardContainer>
                    <CurrencySelect
                        condensed
                        viewOnly={props.viewOnly}
                        {...getFormikProps(addPathPrefix(path, 'currency'), formProps)}
                    />

                    <DeclarationNumberInput
                        viewOnly={props.viewOnly}
                        disabled={props.productDisabled ?? false}
                        {...getFormikProps(addPathPrefix(path, 'currencyAmount'), formProps)}
                        refNumber="4.9"
                        label="Amount"
                        refTooltip="Enter the amount in the selected currency. The amount in EUR will be calculated and updated after the declaration is saved."
                        refClicked={(ref) => handleToggleHelp(ref, props)}
                        condensed
                    />

                    <FormSelect
                        viewOnly={props.viewOnly}
                        {...getFormikProps(addPathPrefix(path, 'additionsDeductionsCode'), formProps)}
                        refNumber="4.9"
                        disabled={props.productDisabled ?? false}
                        label={t('code')}
                        selectOptions={aisCodelists?.additionsDeductionsCode}
                        tooltip={getH1TooltipsByRefNumberAndField('4.9', t('Additions Deductions - Code'))}
                        refClicked={(ref) => handleToggleHelp(ref, props)}
                        condensed
                        codeValidation={[validators.exact(2)]}
                    />

                    <DeclarationNumberInput
                        disabled
                        {...getFormikProps(addPathPrefix(path, 'amount'), formProps)}
                        refNumber="4.9"
                        label="Amount in EUR"
                        placeholder="Amount in EUR"
                        refTooltip="This will be updated automatically after the declaration is saved."
                        refClicked={(ref) => handleToggleHelp(ref, props)}
                        condensed
                    />
                </FormCardContainer>
            )}
        />
    );
};
export default AdditionsDeductionsCard;
